import { LABELS } from '@/constants/common/message.constants'

import { type UserMeTenantPartnerExEntity } from '../../aspida/@types'

/**
 * パートナーロール
 */
export type PartnerRole = UserMeTenantPartnerExEntity['role']

export type PartnerPermissionRole = 'NONE' | 'ALLOWED'

export const PERMISSION_ROLE = {
  NONE: 'NONE',
  ALLOWED: 'ALLOWED'
} as const satisfies Record<PartnerPermissionRole, PartnerPermissionRole>

export const PARTNER_ROLE = {
  /** 管理者 */
  MANAGER: 'MANAGER',
  /** 担当者 */
  STAFF: 'STAFF',
  /** ドライバー */
  DRIVER: 'DRIVER'
} as const satisfies Record<PartnerRole, PartnerRole>

export const PARTNER_ROLE_LABEL = {
  [PARTNER_ROLE.MANAGER]: LABELS.PARTNER_ROLE_MANAGER,
  [PARTNER_ROLE.STAFF]: LABELS.PARTNER_ROLE_STAFF,
  [PARTNER_ROLE.DRIVER]: LABELS.PARTNER_ROLE_DRIVER
} as const satisfies Record<PartnerRole, string>
